import { Fragment } from 'react';
import Directory from '../../components/directory/directory';

const Home = () => {
    return (

        <Fragment>
            <Directory />

        </Fragment>
    );
}

export default Home;
